"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightAdminModal = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var userGroups_1 = require("utils/userGroups");
var GroupMultiSelection_1 = require("components/GroupMultiSelection");
var translationKeys = {
    HEADER: 'userfront/project/teamMembers/createNewLightAdminGroup',
    NAME: 'userfront/project/teamMembers/lightAdministratorName',
    DESCRIPTION: 'userfront/project/teamMembers/userProfileDescription',
    INVITE_RIGHT: 'userfront/project/teamMembers/inviteRight',
    INVITE_RIGHT_PLACEHOLDER: 'userfront/project/teamMembers/userProfileName',
    FAIL_MESSAGE: 'userfront/project/teamMembers/lightAdminGroupSaveFailed'
};
var isFilesFeatureGroup = function (group) {
    return group.category.features && group.category.features.includes('FILESTAB');
};
var isRegularUserGroup = function (group) {
    return ['NormalUserGroup', 'CategoryUserGroup'].includes(group.category.type);
};
var LightAdminModal = function (props) {
    return (React.createElement(sok_ui_1.Modal, { isOpen: ['CREATE', 'EDIT'].includes(props.createEdit.status), className: "project-members-modal-create-light-admin-group" },
        React.createElement(sok_ui_1.Header, { onClose: props.toggleModal }, (0, translation_1.getLocalization)(translationKeys.HEADER)),
        React.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
                var category = (0, userGroups_1.getCategoryByType)(props.groups, 'LightAdminCategoryUserGroup');
                if (props.createLightAdmin && props.currentProject && category)
                    props.createLightAdmin({
                        projectId: props.currentProject.id,
                        categoryId: category.id,
                        name: props.name.trim(),
                        description: props.description.trim(),
                        inviteRightsTo: props.inviteRightsTo.map(function (group) { return group.id; })
                    });
                else if (props.onSave) {
                    props.onSave({
                        projectId: props.currentProject.id,
                        id: props.createEdit.id,
                        name: props.name.trim(),
                        description: props.description.trim(),
                        inviteRightsTo: props.inviteRightsTo.map(function (group) { return group.id; })
                    });
                }
            } },
            React.createElement(sok_ui_1.Container, null,
                React.createElement("div", { className: 'content' },
                    React.createElement(sok_ui_1.Row, null,
                        React.createElement(sok_ui_1.Column, null,
                            React.createElement("label", { htmlFor: 'groupname' }, (0, translation_1.getLocalization)(translationKeys.NAME)),
                            React.createElement(sok_ui_1.TextInput, { id: 'groupname', value: props.name, placeholder: (0, translation_1.getLocalization)(translationKeys.NAME), onChange: function (e) {
                                    return props.setName(e.target.value.toString());
                                }, autoFocus: true }),
                            React.createElement(sok_ui_1.Column, null,
                                React.createElement("label", { htmlFor: 'groupdescription' }, (0, translation_1.getLocalization)(translationKeys.DESCRIPTION)),
                                React.createElement(sok_ui_1.TextInput, { id: 'groupdescription', value: props.description, placeholder: (0, translation_1.getLocalization)(translationKeys.DESCRIPTION), onChange: function (e) {
                                        return props.setDescription(e.target.value.toString());
                                    }, autoFocus: true }))),
                        React.createElement(GroupMultiSelection_1.GroupMultiSelection, { labelKey: translationKeys.INVITE_RIGHT, placeholderKey: translationKeys.INVITE_RIGHT_PLACEHOLDER, value: props.inviteRightsTo, onChange: function (value) {
                                props.setInviteRightsTo(value);
                            }, modalOverlaySelector: ".sok-modal-overlay", groups: props.groups
                                .filter(function (group) { return group.groups.length > 0; })
                                .filter(isFilesFeatureGroup)
                                .filter(isRegularUserGroup) }),
                        props.createEdit.isSaving === 'FAILED' && (React.createElement(sok_ui_1.Column, null,
                            React.createElement("span", { className: 'request-failed' }, (0, translation_1.getLocalization)(translationKeys.FAIL_MESSAGE))))))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { disabled: props.createEdit.isSaving === 'SAVING' ||
                        props.name.trim().length === 0 ||
                        props.inviteRightsTo.length === 0, text: (0, translation_1.getLocalization)('userfront/project/teamMembers/save'), color: 'base-green', type: 'submit' }),
                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/project/teamMembers/cancel'), color: 'dark-gray', onClick: props.toggleModal })))));
};
exports.LightAdminModal = LightAdminModal;
